import React from 'react';
import { Skeleton, Row as StyledRow, RowChild, RowBuffer, List } from 'styles';

interface BufferProps {
  width?: string;
}
interface Props {
  bufferProps?: BufferProps;
  rowCount?: number;
  margin?: Margin;
}

const Row = ({ bufferProps }: Props) => (
  <StyledRow padding="0" xsmall={{ padding: { left: '24px', right: '24px' } }}>
    <RowBuffer width="32px" xsmall={{ width: '0' }} {...bufferProps} />
    <RowChild
      direction="column"
      padding={{ bottom: '32px', top: '32px' }}
      xsmall={{ padding: { bottom: '24px', top: '24px' } }}
    >
      <Skeleton
        height="24px"
        variant="secondary"
        width="100%"
        withShimmer
        margin={{ bottom: '16px' }}
      />
      <Skeleton height="16px" variant="secondary" width="100%" withShimmer />
    </RowChild>
  </StyledRow>
);

export const LoadingList = ({ rowCount = 5, margin = '0', ...rest }: Props) => (
  <List data-testid="loading-list" margin={margin} {...rest}>
    {Array.from({ length: rowCount }).map((_, index) => (
      <Row {...rest} key={`loading-row-${index}`} /> // eslint-disable-line react/no-array-index-key
    ))}
  </List>
);
